const SEO = {
	title: "Bijan Saud",
	description:
		"Developer and Application Security Engineer with 7+ years of experience securing enterprise applications, cloud infrastructure, and identity systems. Building secure, scalable software.",
	keywords: [
		"Bijan Saud",
		"Application Security",
		"Software Developer",
		"Full Stack Developer",
		"Cybersecurity",
		"DevSecOps",
		"React",
		"Java",
		"Spring Boot",
		"AWS",
	],
};

export default SEO;
